import { Alert, Text, Button } from '@nimbus-ds/components';
import { Link } from 'react-router-dom';
import { Country } from '@tiendanube/common/src/enums';
import { ShowByTag } from 'App/components';
import ShowByCountry from 'App/components/ShowByCountry/ShowByCountry';
import { NUVEMENVIO_ADMIN_BLOCK } from 'App/featuresFlags';
import { useGetCountry } from 'domains/Auth/hooks';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import { NUVEM_ENVIO_ROUTES } from 'domains/NuvemEnvioCommons/nuvemEnvioRoutes';

function NuvemEnvioAdminBlockingAlert() {
  const t = useTranslationDashboard('billingMessages.nuvemEnvio.adminBlocking');
  const country = useGetCountry();

  return (
    <ShowByCountry allowedCountries={[Country.BR, Country.AR, Country.MX]}>
      <ShowByTag tag={NUVEMENVIO_ADMIN_BLOCK}>
        <Alert appearance="danger" title={t('title')}>
          <Text>{t('description')}</Text>
          <Button
            appearance="primary"
            as={Link}
            to={NUVEM_ENVIO_ROUTES[country]}
          >
            {t('cta')}
          </Button>
        </Alert>
      </ShowByTag>
    </ShowByCountry>
  );
}

export default NuvemEnvioAdminBlockingAlert;
